<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :loading="loading"
      sort-by="calories"
      :loading-text="$table_loading_text"
      :page.sync="page"
      :items-per-page="filter.item_per_page"
      hide-default-footer
      show-select
      item-key="_id"
      v-model="selected"
      @input="$emit('on-selected', selected)"
    >
      <template v-slot:[`item._id`]="{ item }">
        {{
          list
            .map(function (x) {
              return x._id;
            })
            .indexOf(item._id) +
          1 +
          filter.item_per_page * (filter.page - 1)
        }}
      </template>
      <template v-slot:[`item.car_type`]="{ item }">
        {{ carTypeRegistrationCode(item.car_type) }}
      </template>
      <template v-slot:[`item.is_original_document`]="{ item }">
        <div v-if="item.is_original_document">ตัวจริง</div>
        <div v-else>สำเนา</div>
      </template>
      <template v-slot:[`item.tax_filling_date`]="{ item }">
        {{ formatDate(item.tax_data.tax_filling_date) }}
      </template>
      <template v-slot:[`item.extension_tax_fee`]="{ item }">
        {{ item.tax_data.extension_tax_fee | numeral('0,0.00') }}
      </template>

      <template v-slot:[`item.transportation_fee`]="{ item }">
        <!-- {{item.tax_data.transportation_fee | numeral('0,0.00')}} -->
        <v-text-field
          v-model="item.tax_data.transportation_fee"
          :value="item.tax_data.transportation_fee"
          @blur="saveTransportationFee(item)"
          type="number"
          outlined
          dense
          background-color="white"
          single-line
          hide-details
        >
        </v-text-field>
      </template>

      <template v-slot:[`item.tax_round`]="{ item }">
        {{ item.tax_data.tax_round }}
      </template>
      
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn color="grey" small outlined rounded @click="edit(item._id)">
          ดู
        </v-btn>
      </template>

      <template v-slot:footer>
        <cursor-pager
          :page="filter.page"
          :items-per-page="filter.item_per_page"
          :can-previous="cursorHistory.length > 1"
          :can-next="hasMore"
          :loading="loading"
          @previous="goPreviousPage"
          @next="goNextPage"
          @change-items-per-page="changePageSize"
        />
      </template>
    </v-data-table>

    <v-dialog persistent scrollable max-width="900" v-model="dialogForm">
      <InProgressForm :item="dialogFormData" @on-close="closeDialog" />
    </v-dialog>
  </div>
</template>

<script>
import { carTypeRegistrationCode } from '@/components/PrintDocument/carType';
import listFilterMixin from './listFilterMixin';
import InProgressForm from './InProgressForm';

import * as moment from 'moment';

export default {
  components: {
    InProgressForm,
  },
  mixins: [listFilterMixin],
  props: ['taxRenewalRound'],
  data: () => ({
    dialogForm: false,
    dialogFormData: null,

    selected: [],
    loading: true,
    page: 1,
    list: [],
    headers: [
      { text: 'ลำดับ', value: '_id', filterable: false },
      { text: 'ทะเบียน', value: 'car_plate', filterable: false },
      { text: 'จังหวัด', value: 'province', filterable: false },
      { text: 'ประเภท', value: 'car_type', filterable: false },
      { text: 'เอกสาร', value: 'is_original_document', filterable: false },
      { text: 'วันที่นัดรับ', value: 'tax_filling_date', filterable: false },
      { text: 'ค่าภาษี', value: 'extension_tax_fee', filterable: false },
      { text: 'ขนส่งเก็บ', value: 'transportation_fee', filterable: false },
      { text: 'รอบต่อภาษี', value: 'tax_round', filterable: false },
      { text: 'โน๊ต', value: 'note', filterable: false },
      { text: '', value: 'actions', filterable: false },
    ],
    isCar: true,
    filter: {
      branch_id: null,
      tracking_type: 0,
      tracking_status: 1,
      tax_renewal_round: '',
      car_type_filter: 0,
      item_per_page: 20,
      page: 1,
      start_with: '',
    },
  }),
  mounted() {
    this.filter.branch_id = this.$store.state.selected_branch._id;
    this.getData();
  },
  methods: {
    carTypeRegistrationCode,
    async getData() {
      this.loading = true;
      let body = {
        token: this.$jwt.sign(this.filter, this.$privateKey, {
          noTimestamp: true,
        }),
      };
      await this.$axios
        .post(`${this.$baseUrl}/process/get_process`, body)
        .then((res) => {
          this.list = res.result.data;
          this.list.forEach((item, i) => {
            this.list[i].tax_data.transportation_fee =
              item.tax_data.transportation_fee == 0
                ? item.tax_data.extension_tax_fee
                : item.tax_data.transportation_fee;
          });
          this.applyPageResult(res.result);
          this.$emit('input', res.result.total_tax);
        })
        .catch((err) => {
          console.log('err', err);
          this.$alertServerError({ title: err.error_message });
        });
      this.loading = false;
    },

    openDialog() {
      this.dialogForm = true;
    },
    closeDialog() {
      this.dialogForm = false;
      this.getData();
    },

    async edit(id) {
      this.dialogForm = true;
      let body = {
        token: this.$jwt.sign({ process_id: id }, this.$privateKey, {
          noTimestamp: true,
        }),
      };
      await this.$axios
        .post(`${this.$baseUrl}/process/get_by_id`, body)
        .then((res) => {
          this.dialogFormData = res.result;
        })
        .catch((err) => {
          console.log('err', err);
          this.$alertServerError({ title: err.error_message });
        });
    },
    // the fee a row shows: the saved one, or the tax when none was saved yet
    normalizeSelectedRow(row) {
      const tax = row.tax_data;
      tax.transportation_fee = tax.transportation_fee == 0 ? tax.extension_tax_fee : tax.transportation_fee;
      return row;
    },
    async saveTransportationFee(item) {
      let payload = {
        process_id: item._id,
        tax_data: {
          transportation_fee: parseFloat(item.tax_data.transportation_fee),
        },
        insurance_data: {},
        transport_data: {},
      };
      let body = {
        token: this.$jwt.sign(payload, this.$privateKey, { noTimestamp: true }),
      };
      await this.$axios
        .post(`${this.$baseUrl}/process/edit_process`, body)
        .then((res) => {
          // a selected copy of this row (selected on another page) must get the new fee too
          const picked = this.selected.find((x) => x._id === item._id);
          if (picked && picked !== item) picked.tax_data.transportation_fee = item.tax_data.transportation_fee;
          this.getData();
        })
        .catch((err) => {
          console.log('err', err);
          this.$alertServerError({ title: err.error_message });
        });
    },
    formatDate(date) {
      if (!date) return '';

      let year = parseInt(moment(date).format('YYYY'));
      let m_d = moment(date).format('DD/MM');
      return `${m_d}/${year + 543}`;
    },
  },

  watch: {
    taxRenewalRound(newval, oldval) {
      if (newval != oldval) {
        this.filter.tax_renewal_round = newval;
        this.reloadForRangeFilter();
      }
    },
  },
};
</script>
